module.exports = __webpack_public_path__ + "static/media/t-rex-asteroide-peligroso.42134cc2.svg";